import { singleton, autoinject, Container } from 'aurelia-framework';
import { ViewFactory } from 'aurelia-templating';

class TemplateScope {
	private templates: { [name:string]:ViewFactory; } = { };

	constructor(private parent: TemplateScope) { }

	register(name: string, template: ViewFactory): void {
		this.templates[name] = template;
	}

	findTemplate(name: string): ViewFactory {
		if (this.templates[name]) {
			return this.templates[name];
		}

		if (this.parent) {
			return this.parent.findTemplate(name);
		}

		return null;
	}
}

@singleton()
export class TemplateFragmentRegistry {
	register(name: string, template: ViewFactory, scopeElement: Element): void {
		let scope = this.ensureScope(scopeElement);

		scope.register(name, template);
	}

	get(name: string, scopeElement: Element): ViewFactory {
		let scope = this.findTemplateScope(scopeElement);
		if (!scope) {
			return null;
		}

		return scope.findTemplate(name);
	}

	isDefined(name: string, scopeElement: Element): boolean {
		let scope = this.findTemplateScope(scopeElement);
		if (!scope) {
			return false;
		}

		return !!scope.findTemplate(name);
	}

	private ensureScope(scopeElement: Element): TemplateScope {

		let untypedElement = <any>scopeElement;
		if (!untypedElement.templateScope) {
			untypedElement.templateScope = new TemplateScope(this.findTemplateScope(scopeElement));
		}

		return <TemplateScope>untypedElement.templateScope;
	}

	private findTemplateScope(scopeElement: Element): TemplateScope {
		let untypedElement = <any>scopeElement;
		if (untypedElement.templateScope) {
			return <TemplateScope>untypedElement.templateScope;
		}

		if (scopeElement.parentElement) {
			return this.findTemplateScope(scopeElement.parentElement);
		}

		return null;
	}
}
